import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, BarChart3, Shield, Settings, Activity, Users, Zap, Download, AlertTriangle } from 'lucide-react';

const quickActions = [
  {
    icon: <BarChart3 className="h-5 w-5 text-shiftleft-600" />,
    title: 'Live DMV Query',
    description: 'Run DMV queries and view live results in a table.',
    action: () => {},
    badge: 'New',
  },
  {
    icon: <CheckCircle className="h-5 w-5 text-green-600" />,
    title: 'Query Templates',
    description: 'Browse and copy example queries for each DMV.',
    action: () => {},
    badge: '',
  },
  {
    icon: <BarChart3 className="h-5 w-5 text-purple-600" />,
    title: 'Dashboards',
    description: 'Visualize key metrics and trends with charts.',
    action: () => {},
    badge: '',
  },
  {
    icon: <AlertTriangle className="h-5 w-5 text-red-600" />,
    title: 'Alerts & Recommendations',
    description: 'See critical findings and get actionable advice.',
    action: () => {},
    badge: '',
  },
  {
    icon: <Download className="h-5 w-5 text-gray-600" />,
    title: 'Export & Share',
    description: 'Export results as CSV, Excel, or PDF.',
    action: () => {},
    badge: '',
  },
  {
    icon: <Settings className="h-5 w-5 text-gray-600" />,
    title: 'Custom DMV Collections',
    description: 'Save and manage your favorite DMVs.',
    action: () => {},
    badge: '',
  },
  {
    icon: <Users className="h-5 w-5 text-shiftleft-700" />,
    title: 'Drilldown & Linking',
    description: 'Drill into details and link related DMVs.',
    action: () => {},
    badge: '',
  },
  {
    icon: <Activity className="h-5 w-5 text-orange-600" />,
    title: 'Scheduling & Automation',
    description: 'Schedule diagnostics and automate checks.',
    action: () => {},
    badge: '',
  },
  {
    icon: <Shield className="h-5 w-5 text-shiftleft-800" />,
    title: 'Security & Permissions',
    description: 'Check security best practices and compliance.',
    action: () => {},
    badge: '',
  },
  {
    icon: <Zap className="h-5 w-5 text-yellow-600" />,
    title: 'Integrations',
    description: 'Connect with monitoring and ticketing tools.',
    action: () => {},
    badge: '',
  },
];

export const DiagnosticsQuickActions: React.FC = () => (
  <div className="p-4 space-y-4">
    <h2 className="text-xl font-bold text-shiftleft-900 mb-2">Diagnostics Quick Actions</h2>
    <div className="grid grid-cols-1 gap-4">
      {quickActions.map((action) => (
        <Card key={action.title} className="w-full">
          <CardHeader className="flex flex-row items-center gap-3 pb-2">
            {action.icon}
            <CardTitle className="text-base font-semibold flex-1">{action.title}</CardTitle>
            {action.badge && <Badge variant="default" className="ml-2">{action.badge}</Badge>}
          </CardHeader>
          <CardContent>
            <div className="text-sm text-gray-700 mb-2">{action.description}</div>
            <button className="w-full bg-shiftleft-600 text-white py-1.5 px-4 rounded-lg hover:bg-shiftleft-700 transition-colors text-sm font-medium" onClick={action.action} disabled>
              Coming Soon
            </button>
          </CardContent>
        </Card>
      ))}
    </div>
  </div>
);
